export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Accounts',
        route: 'accounts',
        icon: 'UsersIcon',
      },
      {
        title: 'Purchases',
        route: 'purchases',
        icon: 'ShoppingCartIcon',
      },
      {
        title: 'Devices',
        route: 'devices',
        icon: 'CpuIcon',
      },
      {
        title: 'Books',
        route: 'books',
        icon: 'BookIcon',
      },
      {
        title: 'Reviews',
        route: 'reviews',
        icon: 'StarIcon',
      },
      {
        title: 'ChessPub Books',
        route: 'cpbooks',
        icon: 'BookIcon',
      },
      {
        title: 'Puzzles',
        route: 'puzzles',
        icon: 'BarChartIcon',
      },
      {
        title: 'Notifications',
        route: 'notifications',
        icon: 'BellIcon',
      },
      {
        title: 'Settings',
        route: 'settings',
        icon: 'SettingsIcon',
      },
    ],
  },
]
